// extracted by mini-css-extract-plugin
module.exports = {"container":"FollowingTooltip_container__08FrB","tooltip":"FollowingTooltip_tooltip__ZZ5Kq"};